import GeneralMessage from '../../components/UI/GeneralMessage';
import Grid from '../../components/UI/Grid/Grid';

const PhrasesForApprovalPanel = ({ hook }) => {
    const { successMessage, generalErrorList, forAcceptanceGridHeaders, forAcceptanceGridData } =
        hook;

    const element = (
        <div className="animated fadeIn">
            <GeneralMessage
                className="c-msg"
                successMessage={successMessage}
                errorList={generalErrorList}
            />

            <div className="container-fluid card p-4 mb-5">
                <div className="row">
                    <div className="col-12">
                        <h2 className="display-5">Phrases to be reviewed</h2>
                        <hr />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Grid columns={forAcceptanceGridHeaders} data={forAcceptanceGridData} />
                    </div>
                </div>
            </div>
        </div>
    );
    return element;
};

export default PhrasesForApprovalPanel;
